module.exports = __webpack_public_path__ + "static/media/city.e927a091.svg";